module.exports = __webpack_public_path__ + "components/resort-snow-depths-snippet/static/mountain-0f7293b6ccd54212f5c849b1daa6d802.svg";